import signup from './signup';

export default signup;
